<template>
    <div>
        <h1 v-if="agileSubscriptions.length" class="font-weight-light text-center">Agile TV</h1>
        <v-card class="my-2" v-for="agile in agileSubscriptions" :key="agile.id">
            <v-card-title>
                <h5 class="font-weight-light"> {{ agile.tariffName }} </h5>
                <v-spacer></v-spacer>
                <v-btn depressed color="primary" class="font-weight-light">{{ agile.installationPhone }}</v-btn>
            </v-card-title>

            <v-card-text>
                <div class="d-flex justify-space-between align-center">
                    <div class="d-flex align-center">
                        <h5 class="font-weight-light">Estado</h5>
                        <v-icon
                            class="ml-2"
                            right
                            :small="$vuetify.breakpoint.smAndDown"
                            :color="agile.status === 'ACTIVATED' ? 'green' : 'red'"
                        >
                            mdi-circle
                        </v-icon>
                    </div>
                    <div class="d-flex align-center">
                        <h5 class="font-weight-light">Principal</h5>
                        <v-icon
                            class="ml-2"
                            right
                            :small="$vuetify.breakpoint.smAndDown"
                            :color="agile.isMainLine ? 'green' : 'red'"
                        >
                            mdi-circle
                        </v-icon>
                    </div>
                    <AgentUserInfo :expeditionUserInfo="agile.ownerUserInfo"/>
                </div>

                <v-divider class="my-2"></v-divider>

                <AgentPromos :selectedContractId="selectedContractId" :serviceID="agile.id" serviceType="agileSubscriptions" />
                
                <v-divider class="my-2"></v-divider>

                <AgentPenalties class="d-flex flex-wrap justify-center" :selectedContractId="selectedContractId" :serviceNumber="agile.installationPhone" :types="['AGILETV']"/>

                <v-divider class="my-2"></v-divider>

                <div :class="!$vuetify.breakpoint.smAndDown ? 'd-flex justify-space-between' : ''">
                    <div>
                        <h3 class="font-weight-light mt-4 mb-2"><strong>Información de la Tarifa</strong></h3>
                        <div class="d-flex flex-column justify-center">
                            <!-- <h5 class="font-weight-light grey--text"><strong>ID:</strong> {{ agile.tariffId }}</h5> -->
                            <h5 class="font-weight-light grey--text"><strong>Nombre:</strong> {{ agile.tariffName }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Sub-Tipo:</strong> {{ agile.subType }}</h5>
                        </div>
                    </div>
                    <div>
                        <h3 class="font-weight-light mt-4 mb-2"><strong>Información de la Línea</strong></h3>
                        <div class="d-flex flex-column justify-center">
                            <!-- <h5 class="font-weight-light grey--text"><strong>Principal:</strong> {{ agile.isMainLine }}</h5> -->
                            <!-- <h5 class="font-weight-light grey--text"><strong>Estado:</strong> {{ agile.status }}</h5> -->
                            <h5 class="font-weight-light grey--text"><strong>Tipo:</strong> {{ agile.type }}</h5>
                            <!-- <h5 class="font-weight-light grey--text"><strong>Segmento:</strong> {{ agile.segmentType }}</h5> -->
                        </div>
                    </div>
                </div>


                <v-divider class="my-2"></v-divider>

                <div :class="!$vuetify.breakpoint.smAndDown ? 'd-flex justify-space-between' : ''">
                    <div>
                        <h3 class="font-weight-light mt-4 mb-2"><strong>Información de Activación</strong></h3>
                        <div class="d-flex flex-column justify-center">
                            <h5 class="font-weight-light grey--text"><strong>Fecha de Activación:</strong> {{ formatDateYYYYMMDD(agile.metadataInfo.activationDate) }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Fecha de Desactivación:</strong> {{ formatDateYYYYMMDD(agile.metadataInfo.deactivationDate) }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Razón de Desactivación:</strong> {{ agile.metadataInfo.deactivationReason }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Razón de Desactivación Enum:</strong> {{ agile.metadataInfo.deactivationReasonEnum }}</h5>
                        </div>
                    </div>
                    <div>
                        <h3 class="font-weight-light mt-4 mb-2"><strong>Otras Fechas</strong></h3>
                        <div class="d-flex flex-column justify-center">
                            <h5 class="font-weight-light grey--text"><strong>Fecha de Instalación:</strong> {{ formatDateYYYYMMDD(agile.metadataInfo.installationDate) }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Fecha de Pre-Activación:</strong> {{ formatDateYYYYMMDD(agile.metadataInfo.preActivationDate) }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Fecha de Venta:</strong> {{ formatDateYYYYMMDD(agile.metadataInfo.sellDate) }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Fecha de Desagrupación:</strong> {{ formatDateYYYYMMDD(agile.metadataInfo.unbundledDate) }}</h5>
                        </div>
                    </div>
                </div>
            </v-card-text>

            <v-card-actions :class="!$vuetify.breakpoint.smAndDown ? 'd-flex justify-space-between align-center' : 'd-flex flex-column'">
                <v-btn
                    x-small
                    depressed
                    outlined
                    color="primary"
                    class="mb-2"
                    @click="agentContract(agile.contractUrl.split('/').pop()); isOpen = true;"
                >
                    <v-icon small left>mdi-file-document</v-icon>
                    Ver Contrato
                </v-btn>
                <AgentUserInfo :expeditionUserInfo="agile.expeditionUserInfo" title="Información de Expedición" />
                <AgentUserInfo :expeditionUserInfo="agile.installationUserInfo" title="Información de Instalación" />
            </v-card-actions>

        </v-card>
    </div>
</template>

<script>
import AgentUserInfo from './AgentUserInfo.vue';
import AgentPromos from './AgentPromos.vue';
import AgentPenalties from './AgentPenalties.vue';
import { mapActions } from 'vuex';
import { formatDateYYYYMMDD } from '@/util/libUtil.js';

export default {
    components: {
        AgentUserInfo,
        AgentPromos,
        AgentPenalties,
    },
    props: {
        agileSubscriptions: {
            type: Array,
        },
        selectedContractId: {
            type: String,
        },
    },
    methods: {
        formatDateYYYYMMDD,
        ...mapActions('agent', ['agentContract']),
    },
    watch: {
        selectedContract(val) {
            this.agiles = val.agile.agileSubscriptions;
        }
    }
};
</script>
